var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContextMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    stroke: "#838383"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9996 6C13.3709 6 13.727 6.1475 13.9896 6.41005C14.2521 6.6726 14.3996 7.0287 14.3996 7.4C14.3996 7.7713 14.2521 8.1274 13.9896 8.38995C13.727 8.6525 13.3709 8.8 12.9996 8.8C12.6283 8.8 12.2722 8.6525 12.0097 8.38995C11.7471 8.1274 11.5996 7.7713 11.5996 7.4C11.5996 7.0287 11.7471 6.6726 12.0097 6.41005C12.2722 6.1475 12.6283 6 12.9996 6Z",
    fill: "#838383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9996 11.6C13.3709 11.6 13.727 11.7475 13.9896 12.0101C14.2521 12.2726 14.3996 12.6287 14.3996 13C14.3996 13.3713 14.2521 13.7274 13.9896 13.99C13.727 14.2525 13.3709 14.4 12.9996 14.4C12.6283 14.4 12.2722 14.2525 12.0097 13.99C11.7471 13.7274 11.5996 13.3713 11.5996 13C11.5996 12.6287 11.7471 12.2726 12.0097 12.0101C12.2722 11.7475 12.6283 11.6 12.9996 11.6Z",
    fill: "#838383"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9996 17.2C13.3709 17.2 13.727 17.3475 13.9896 17.6101C14.2521 17.8726 14.3996 18.2287 14.3996 18.6C14.3996 18.9713 14.2521 19.3274 13.9896 19.59C13.727 19.8525 13.3709 20 12.9996 20C12.6283 20 12.2722 19.8525 12.0097 19.59C11.7471 19.3274 11.5996 18.9713 11.5996 18.6C11.5996 18.2287 11.7471 17.8726 12.0097 17.6101C12.2722 17.3475 12.6283 17.2 12.9996 17.2Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextMenu);
export default __webpack_public_path__ + "static/media/context_menu.73860d7e4a622b7a7953257f291c8496.svg";
export { ForwardRef as ReactComponent };